import React from 'react'

import TicketOption from '../TicketOption'

const Tickets = ({className}) => (
  <div className={`tickets ${className}`} id="tickets">
    <h2 className="tickets-title">Get your tickets</h2>
    <ul className="tickets-list">
        <TicketOption 
          type="Late Bird" 
          available={true} 
          info="Late Bird ticket is now on sale!" 
        />
        <TicketOption  
          type="Diversity Ticket" 
          available={"out"} 
          info="With this ticket, you actively contribute to our diversity program to offer free tickets for underrepresented community members." 
        />
        <TicketOption 
          type="Early Bird" 
          available={"out"}
          info="Fancy early price ticket just for you!" 
        />
        <TicketOption 
          type="General Sale" 
          available={"out"}
          info="General Ticket price will increase slightly every two weeks. Catch them while you can!" 
        />
    </ul>
  </div>
)

Tickets.defaultProps = {
  className: ""
}

export default Tickets



// WEBPACK FOOTER //
// ./src/components/Tickets/index.js